$(document).ready(function () {
  var $hamburger = $('.hamburger')
  var $nav = $('#main-navigation')
  $hamburger.on('click', function (e) {
    $hamburger.toggleClass('is-active')
    $nav.toggleClass('is-active')
  })

  $project_carousel = $('.project-carousel').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    fullscreen: true,
    arrowShape: 'M26.6,49.7L72.1,0.4L75,3.1L31.9,49.7L75,96.9l-2.9,2.6L26.6,49.7z',
  })

  $project_carousel.on('fullscreenChange.flickity', function (event, isFullscreen) {
    console.log('is it?', isFullscreen)
    $project_carousel.flickity('resize')
    setTimeout(function () {
      $project_carousel.flickity('resize')
      console.log('CLEEEK')
    }, 20)
    setTimeout(function () {
      $project_carousel.flickity('resize')
      console.log('CLEEEK 2')
    }, 200)
  })
  $('.homepage-hero-carousel').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    arrowShape: 'M26.6,49.7L72.1,0.4L75,3.1L31.9,49.7L75,96.9l-2.9,2.6L26.6,49.7z',
  })

  $('.js-project-carousel-image').click(function () {
    // $project_carousel.flickity('viewFullscreen')
  })
  console.log('dd!')
  $('.js-go-fullscreen').click(function () {
    console.log('CLICKKKKKK')

    var carousel = $(this).closest('.project-carousel')
    var index = $(this).closest('.image').index()
    carousel.flickity('select', index)
    carousel.flickity('viewFullscreen')

    //carousel.flickity('resize')
  })

  function loadImages() {
    $('[data-img-bg]').each(function () {
      var el = $(this)
      var src = $(this).data('img-bg')
      if (src) {
        var img = new Image()
        img.style.display = 'none'
        img.src = src
        el.css('background-image', 'url(' + src + ')')
        img.onload = function () {
          el.addClass('loaded')
        }
      }
    })
    $('[data-img-src]').each(function () {
      console.log('img src')
      var el = $(this)
      var src = $(this).data('img-src')
      var srcset = $(this).data('img-srcset')
      if (src) {
        var img = new Image()
        img.style.display = 'none'
        img.src = src
        el.attr('src', src)
        if (srcset) {
          el.attr('srcset', srcset)
        }
        img.onload = function () {
          el.addClass('loaded')
        }
      }
    })
  }
  loadImages()
  /**
   *  END - Lazy Load Imagaes
   */
})
